/* @ngInject */
export function SelectEmployeeOccupationController($ngRedux, EmployeeService) {
    var ctrl = this;
    var unsubscribe = angular.noop;

    ctrl.$onInit = function() {
        unsubscribe = $ngRedux.connect(mapStateToThis, {})(this);
        ctrl.options = [];

        EmployeeService.getOccupations().then(function(items) {
            ctrl.options = items;
        });
    };

    ctrl.$onDestroy = function() {
        unsubscribe();
    };

    ctrl.onSelect = function() {
        if (ctrl.selectedOption) {
            $ngRedux.dispatch({
                type: 'EMPLOYEE_OCCUPATION_SELECTED',
                id: ctrl.identifier,
                occupation: ctrl.selectedOption
            });
        }
    };

    function mapStateToThis(state) {
        return {
            selectedOption: state.employees[ctrl.identifier].filter.occupation,
        };
    }
}
